/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityCustomTagRequest
 */
export interface UpdateFacilityCustomTagRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the UpdateFacilityCustomTagRequest interface.
 */
export function instanceOfUpdateFacilityCustomTagRequest(value: object): value is UpdateFacilityCustomTagRequest {
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    return true;
}

export function UpdateFacilityCustomTagRequestFromJSON(json: any): UpdateFacilityCustomTagRequest {
    return UpdateFacilityCustomTagRequestFromJSONTyped(json, false);
}

export function UpdateFacilityCustomTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityCustomTagRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function UpdateFacilityCustomTagRequestToJSON(json: any): UpdateFacilityCustomTagRequest {
    return UpdateFacilityCustomTagRequestToJSONTyped(json, false);
}

export function UpdateFacilityCustomTagRequestToJSONTyped(value?: UpdateFacilityCustomTagRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'facility_ids': value['facility_ids'],
    };
}

